import React from 'react'

export default function VisiGiftApproveExhibitor() {
  return (
    <div>VisiGiftApproveExhibitor</div>
  )
}
